<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical :headerTitle="mainData.__created__ ? '안전책임자 관리 추가' : '안전책임자 관리 상세'" device="web">
        <template v-slot:body>
          <v-form ref="form">
            <v-simple-table class="custom-table">
              <template v-slot:default>
                <colgroup>
                  <col style="width: 15%" />
                  <col style="width: 85%" />
                </colgroup>
                <tbody>
                  <tr>
                    <td class="text-center tableTitle required">안전책임자 관리명</td>
                    <td class="text-left">
                      <v-text-field
                        ref="manageNm"
                        v-model="editingData.manageNm"
                        :rules="rules"
                        placeholder="안전책임자 관리명을 작성하세요."
                        solo
                        hide-details="auto"
                        spellcheck="false"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center tableTitle">조직구성 차수</td>
                    <td class="readonly">
                      <v-text-field
                        ref="orgnOrder"
                        :value="mainData.orgnOrder"
                        solo
                        hide-details="auto"
                        spellcheck="false"
                        readonly
                        background-color="readonly"
                      />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span>
                  <span class="editor-label">평가권한</span>
                  <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
                </span>
              </template>

              <div>{{ '①경영책임자 : 안전보건관리책임자, 관리감독자 ' }}</div>
              <div>{{ '③안전보건관리책임자 : 현장안전관리자, 현장관리자 ' }}</div>
              <div>{{ '(* 평가하려는 직책은 조직도에 등록되어 있어야 조회할 수 있습니다.)' }}</div>
            </v-tooltip>
            <v-simple-table v-if="editingData.safetyManagers.length" class="mt-5 custom-table">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="text-center tableTitle" rowspan="2">직책</td>
                    <td class="text-center tableTitle" rowspan="2">성명</td>
                    <td class="text-center tableTitle" rowspan="2" style="width: 70%">담당업무</td>
                    <td class="text-center tableTitle" colspan="3">평가</td>
                  </tr>
                  <tr>
                    <td class="text-center tableTitle">양호</td>
                    <td class="text-center tableTitle">보통</td>
                    <td class="text-center tableTitle">미흡</td>
                  </tr>

                  <template v-for="manager in editingData.safetyManagers">
                    <tr v-for="(assessment, index) in manager.assessments" :key="`${manager.esgHrNo}_${assessment.authDivItem}`">
                      <td v-if="index === 0" class="text-center" :rowspan="`${manager.assessments.length}`">{{ manager.authDivNm }}</td>
                      <td v-if="index === 0" class="text-center" :rowspan="`${manager.assessments.length}`">{{ manager.managerNm }}</td>
                      <td>{{ assessment.authDivItemNm }}</td>
                      <td>
                        <div class="d-flex justify-center align-center">
                          <v-checkbox
                            hide-details
                            v-model="assessment.assessmentVal"
                            true-value="good"
                            :false-value="null"
                            :readonly="!assessment.__created__ && assessment.assessmentVal == 'good'"
                          ></v-checkbox>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-center align-center">
                          <v-checkbox
                            hide-details
                            v-model="assessment.assessmentVal"
                            true-value="normal"
                            :false-value="null"
                            :readonly="!assessment.__created__ && assessment.assessmentVal == 'normal'"
                          ></v-checkbox>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-center align-center">
                          <v-checkbox
                            hide-details
                            v-model="assessment.assessmentVal"
                            true-value="insufficient"
                            :false-value="null"
                            :readonly="!assessment.__created__ && assessment.assessmentVal == 'insufficient'"
                          ></v-checkbox>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
              <!-- <template v-else>
                <tr rowspan="1" colspan="3">조회 가능한 데이터가 없습니다. 조직도 또는 직책을 확인해주세요.</tr>
              </template>-->
            </v-simple-table>
            <v-simple-table v-else class="mt-5 custom-table">
              <template v-slot:default>
                <tbody>
                  <tr class="text-center" rowspan="3">
                    <td class="text-center">조회가능한 데이터가 없습니다. 조직도 또는 직책을 확인해주세요.</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-form>
        </template>
      </i-card-vertical>
      <i-card-right :useBtnList="buttonUseList" @btnSave="btnSave()" @btnSearch="btnSearch()" @btnDelete="btnDelete()" @btnPrint="btnPrint">
        <template v-slot:customBtn>
          <i-icon-button color="btn_text" :text="'목록으로'" height="92px" :icon="'back'" @click="btnCancel()" :appendDivider="true"></i-icon-button>
        </template>
      </i-card-right>
    </v-sheet>
  </v-container>
</template>

<script>
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import { getCompanyList } from '@/api/baseManage/compManage'
import {
  getSafetyManagerManageDetail,
  saveSafetyManagerManage,
  deleteSafetyManagerManage,
  getRptSafetyManage,
} from '@/api/evaluationImprovement/safetyManagerManage.js'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {},
  data() {
    return {
      rules: [
        (value) => {
          if (value) return true
          return '필수입력 값입니다.'
        },
      ],
      buttonUseList: [
        'btnSearch', //조회
        'btnSave', //저장
        'btnDelete',
        'btnPrint', // 출력
      ],
      compList: [],
      mainData: {},
      editingData: { safetyManagers: [] },
      popupVisible: false,
    }
  },
  beforeMount() {
    Promise.all([getCompanyList({ clntId: this.getClntId() })]).then((response) => {
      let failedResponse = response.find((element) => !element.success)
      if (failedResponse == null) {
        this.compList = response[0].list
      } else {
        this.$vToastify.error({ body: failedResponse.msg })
        this.vToastify(failedResponse.msg, 'error')
      }
    })
  },
  mounted() {},
  activated() {
    if (!this.$route.params.data) {
      this.$router.go(-1)
      return
    }
    this.mainData = this.$route.params.data
    console.log(this.mainData)
    this.btnSearch(true)
  },
  methods: {
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    //------------------------------------------
    //  조회
    //------------------------------------------
    btnSearch(isNotify) {
      this.openLoading('searching')
      this.mainData.createdBy = this.getUserCd()
      getSafetyManagerManageDetail(this.mainData, isNotify)
        .then((response) => {
          this.editingData = response
        })
        .finally(() => {
          this.endLoading()
        })
    },
    //------------------------------------------
    //  저장
    //------------------------------------------
    btnSave() {
      const validate = this.$refs.form.validate()

      if (!validate) {
        this.vSnackbar(this.$t('저장 입력 항목을 확인해주세요.'), 'warning')
        return
      }
      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        (current) => {
          this.openLoading('saving')
          this.editingData.createdBy = this.getUserCd()
          saveSafetyManagerManage(this.editingData, true)
            .then((response) => {
              this.editingData = response
              this.mainData.writeDt = this.editingData.writeDt
              this.mainData.docNo = this.editingData.docNo
              this.mainData.__created__ = false
              this.$store.state.ui.searchFlag = true
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    //------------------------------------------
    //  삭제
    //------------------------------------------
    btnDelete() {
      if (this.mainData.__created__) {
        this.vSnackbar(this.$t('저장되지 않은 관리사항입니다.'), 'warning')
        return
      }
      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        (current) => {
          this.openLoading('deleting')
          deleteSafetyManagerManage([this.mainData], true)
            .then((res) => {
              this.$store.state.ui.searchFlag = true
              this.$router.go(-1)
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    btnCancel() {
      this.vToastifyPrompt(this.$t('작성을 중지하고 이전 페이지로 이동하시겠습니까?'), 'info', async (current) => {
        const toRouter = {
          name: 'SafetyManagerManage',
          params: {
            search: true,
          },
        }
        this.$router.push(toRouter)
        return
      })
    },
    btnPrint(type) {
      let searchParams = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        writeDt: this.mainData.writeDt,
        docNo: this.mainData.docNo,
        type: type,
      }
      this.openLoading()
      //PDF 출력
      getRptSafetyManage(searchParams)
        .then((res) => {
          this.downloadReport(res)
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
      //window.open(new createObjectURL(blob),"_blank")
    },
  },
}
</script>

<style>
.v-data-table {
  border: 1px solid #e0e0e0;
}
</style>
